import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const AccountAggregatorStatementLayout = ({ banks,userId }) => {
    const {id}=useParams()
  const navigate = useNavigate();
  const location=useLocation()
  const currentBank = new URLSearchParams(location.search).get('bank'); // Get bank query param
  

  const handleBankChange = (bankId) => {
    navigate(`/accountAggregator/banks/${id}?userId=${userId}&bank=${bankId}`); // Use useNavigate for navigation
  };

  return (
    <header className="bg-blue-100 py-4 px-4">
      <nav className="container mx-auto flex">
        <ul className="relative flex border-b-2 border-blue-200">
          {banks?.map((bank, index) => (
            <li key={bank.id} className="relative">
              <button
                onClick={() => handleBankChange(index)}
                className={`
                  text-sm px-4 py-2 transition-colors duration-200
                  ${currentBank === index.toString() ? 'text-blue-600 font-bold' : 'text-gray-800'}
                `}
              >
                {bank.name}
              </button>
              {currentBank === index.toString() && (
                <span
                  className="absolute bottom-0 left-0 w-full h-1 bg-blue-600 rounded-sm"
                ></span>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default AccountAggregatorStatementLayout;
